import { GameScreen } from "./components/GameScreen";

export var react = {
    GameScreen
};